/* src/app/shared-module/components/dialog-link-lead/dialog-link-lead.component.scss */
.save-button {
  --box-shadow: none !important;
  color: white;
  --background: var(--ion-color-secondary-shade) !important;
}
/*# sourceMappingURL=dialog-link-lead.component.css.map */
